import seed from '../data/safepathInfoSeed.json';

/** vn:hue 등 — 다낭 템플릿을 복제한 뒤 문자열만 치환 */
const REGION_INHERIT = {
  'vn:hue': {
    base: 'vn:danang',
    label: { ko: '베트남 · 후에', en: 'Vietnam · Huế', vi: '', ru: '' },
    replacements: {
      다낭: '후에',
      'Da Nang': 'Hue',
    },
  },
};

function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function applyReplacements(value, map) {
  if (typeof value === 'string') {
    let s = value;
    Object.entries(map).forEach(([a, b]) => {
      if (a) s = s.split(a).join(b);
    });
    return s;
  }
  if (Array.isArray(value)) return value.map((x) => applyReplacements(x, map));
  if (value && typeof value === 'object') {
    const out = {};
    Object.keys(value).forEach((k) => {
      out[k] = applyReplacements(value[k], map);
    });
    return out;
  }
  return value;
}

function getRawRegion(regionKey) {
  const rk = String(regionKey || '').toLowerCase();
  const regions = seed.regions || {};
  if (regions[rk]) return { key: rk, block: regions[rk] };
  const inherit = REGION_INHERIT[rk];
  if (inherit?.base && regions[inherit.base]) {
    const cloned = deepClone(regions[inherit.base]);
    const merged = applyReplacements(cloned, inherit.replacements || {});
    return {
      key: rk,
      block: { ...merged, label: inherit.label || merged.label },
      inheritedFrom: inherit.base,
    };
  }
  return { key: rk, block: null };
}

/**
 * @param {string} regionKey e.g. vn:danang
 */
export function getSafePathLifePack(regionKey) {
  const { key, block, inheritedFrom, fallback } = getRawRegion(regionKey);
  if (!block?.categories) {
    return {
      regionKey: key,
      label: {},
      categories: [],
      inheritedFrom: inheritedFrom || null,
      fallback: !!fallback,
    };
  }
  return {
    regionKey: key,
    label: block.label || {},
    categories: block.categories,
    inheritedFrom: inheritedFrom || null,
    fallback: !!fallback,
  };
}

export function getSafePathCategory(regionKey, slug) {
  const pack = getSafePathLifePack(regionKey);
  return pack.categories.find((c) => c.slug === slug) || null;
}

export function safepathSeedVersion() {
  return seed.version || '';
}
